import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Overview")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Watch your smart home data away from home without third party clouds. This service is a part of Robonomics IoT Subscription. Read our wiki for ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("more details")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(". ")

export function render(_ctx, _cache) {
  const _component_robo_card_label_section = _resolveComponent("robo-card-label-section")
  const _component_robo_card_label = _resolveComponent("robo-card-label")
  const _component_robo_link = _resolveComponent("robo-link")
  const _component_robo_card_section = _resolveComponent("robo-card-section")
  const _component_robo_card = _resolveComponent("robo-card")
  const _component_robo_section = _resolveComponent("robo-section")

  return (_openBlock(), _createBlock(_component_robo_section, null, {
    default: _withCtx(() => [
      _createVNode(_component_robo_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_robo_card_label, null, {
            default: _withCtx(() => [
              _createVNode(_component_robo_card_label_section, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_robo_card_section, null, {
            default: _withCtx(() => [
              _hoisted_2,
              _createVNode(_component_robo_link, { href: "https://wiki.robonomics.network/docs/home-assistant-begin/" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}